var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.28571,
    fill: "#202635"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5695 8.72912C17.1711 8.90117 16.7465 9.01532 16.3039 9.07074C16.7593 8.80309 17.1069 8.38235 17.2703 7.87528C16.8457 8.12459 16.377 8.30055 15.8774 8.39883C15.4742 7.97603 14.8998 7.71436 14.2728 7.71436C13.0568 7.71436 12.0776 8.68626 12.0776 9.87761C12.0776 10.049 12.0923 10.2139 12.1285 10.3709C10.3027 10.2831 8.68673 9.42143 7.60128 8.10872C7.41169 8.43242 7.30057 8.80309 7.30057 9.20199C7.30057 9.95096 7.69231 10.615 8.27616 10.9993C7.92334 10.9927 7.57701 10.8918 7.28383 10.7329C7.28383 10.7395 7.28383 10.7481 7.28383 10.7566C7.28383 11.8076 8.04513 12.6806 9.04374 12.8817C8.86503 12.9299 8.66999 12.953 8.46784 12.953C8.32722 12.953 8.18534 12.9452 8.05204 12.9161C8.33664 13.7727 9.14418 14.4023 10.1045 14.4227C9.35721 14.9984 8.4082 15.3452 7.38114 15.3452C7.20096 15.3452 7.02832 15.3374 6.85547 15.3155C7.82833 15.933 8.98138 16.2858 10.2248 16.2858C14.2667 16.2858 16.4766 12.9891 16.4766 10.1315C16.4766 10.0359 16.4732 9.94354 16.4686 9.85186C16.9045 9.54732 17.2709 9.16697 17.5695 8.72912Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b545c3a8.svg";
export { ForwardRef as ReactComponent };